const spinner = {
  base: twSort`border-primary relative inline-block shrink-0 rounded-full after:absolute after:rounded-full after:bg-white`,
  size: {
    xs: twSort`size-4 border-4 after:top-1 after:-left-1 after:size-1`,
    sm: twSort`size-6 border-[0.375rem] after:top-1 after:-left-1.5 after:size-1.5`,
    base: twSort`size-8 border-8 after:top-2 after:-left-2 after:size-2`,
  },
};

import { cn } from '@/_lib/utils';
import { twSort } from '@/_shared';

import type { SpinnerProps } from './types';

export function Spinner({ className = '', animate = true, size = 'base', ...rest }: SpinnerProps) {
  return <div {...rest} className={cn(spinner.base, spinner.size[size], animate ? 'animate-spin' : '', className)} />;
}
